export default {
  // 页面标题和面包屑
  'pages.decoration.title': '装修报备管理',
  'pages.decoration.breadcrumb.person': '人员管理',
  'pages.decoration.breadcrumb.decoration': '装修报备',

  // 副标题配置
  'pages.decoration.subtitle.canEnterEarly': '审核通过后，可以提前',
  'pages.decoration.subtitle.hoursEnter': '小时进入，如果超过',
  'pages.decoration.subtitle.hoursCannotEnter': '小时后将无法进入小区',

  // 按钮
  'pages.decoration.button.settings': '设置',

  // 标签页
  'pages.decoration.tabs.registered': '已登记',
  'pages.decoration.tabs.inProgress': '进行中',
  'pages.decoration.tabs.completed': '已完成',

  // 模态框
  'pages.decoration.modal.config.title': '装修时间配置',
  'pages.decoration.modal.config.save': '保存',
  'pages.decoration.modal.config.cancel': '取消',

  // 表单标签
  'pages.decoration.form.beforeHours.label': '提前进入时间（小时）',
  'pages.decoration.form.beforeHours.placeholder': '请输入提前进入时间',
  'pages.decoration.form.beforeHours.required': '请输入提前进入时间',
  'pages.decoration.form.beforeHours.range': '请输入0-24之间的数字',

  'pages.decoration.form.afterHours.label': '超时限制时间（小时）',
  'pages.decoration.form.afterHours.placeholder': '请输入超时限制时间',
  'pages.decoration.form.afterHours.required': '请输入超时限制时间',
  'pages.decoration.form.afterHours.range': '请输入1-168之间的数字',

  // 消息
  'pages.decoration.message.configUpdateSuccess': '配置更新成功',
  'pages.decoration.message.configUpdateFailed': '配置更新失败',

  // 表格相关
  'pages.decoration.table.title': '装修报备管理',
  'pages.decoration.table.columns.houseInfo': '房屋信息',
  'pages.decoration.table.columns.ownerName': '业主姓名',
  'pages.decoration.table.columns.qrcode': '二维码',
  'pages.decoration.table.columns.decorationName': '装修负责人',
  'pages.decoration.table.columns.decorationPhone': '负责人手机号',
  'pages.decoration.table.columns.decorationCompany': '装修公司',
  'pages.decoration.table.columns.workerCount': '施工人数',
  'pages.decoration.table.columns.startDate': '装修开始时间',
  'pages.decoration.table.columns.endDate': '装修结束时间',
  'pages.decoration.table.columns.status': '状态',
  'pages.decoration.table.columns.createdTime': '创建时间',
  'pages.decoration.table.columns.action': '操作',

  // 按钮
  'pages.decoration.button.create': '新增装修报备',
  'pages.decoration.button.view': '查看',
  'pages.decoration.button.edit': '编辑',
  'pages.decoration.button.delete': '删除',
  'pages.decoration.button.batchDelete': '批量删除',
  'pages.decoration.button.close': '关闭',

  // 状态
  'pages.decoration.status.notStarted': '未开始',
  'pages.decoration.status.inProgress': '进行中',
  'pages.decoration.status.completed': '已完成',
  'pages.decoration.status.unknown': '未知',

  // 详情模态框
  'pages.decoration.detail.title': '装修报备详情',
  'pages.decoration.detail.sections.houseInfo': '房屋信息',
  'pages.decoration.detail.sections.ownerInfo': '业主信息',
  'pages.decoration.detail.sections.decorationInfo': '装修信息',
  'pages.decoration.detail.sections.systemInfo': '系统信息',

  // 字段标签
  'pages.decoration.detail.fields.buildingName': '楼栋名称',
  'pages.decoration.detail.fields.floor': '楼层',
  'pages.decoration.detail.fields.houseNumber': '房号',
  'pages.decoration.detail.fields.ownerName': '业主姓名',
  'pages.decoration.detail.fields.ownerPhone': '业主电话',
  'pages.decoration.detail.fields.ownerEmail': '业主邮箱',
  'pages.decoration.detail.fields.decorationName': '装修负责人',
  'pages.decoration.detail.fields.decorationPhone': '负责人手机号',
  'pages.decoration.detail.fields.decorationCompany': '装修公司',
  'pages.decoration.detail.fields.workerCount': '施工人数',
  'pages.decoration.detail.fields.decorationStatus': '装修状态',
  'pages.decoration.detail.fields.startDate': '装修开始时间',
  'pages.decoration.detail.fields.endDate': '装修结束时间',
  'pages.decoration.detail.fields.createdTime': '创建时间',
  'pages.decoration.detail.fields.updatedTime': '更新时间',

  // 编辑/创建表单
  'pages.decoration.form.create.title': '新增装修报备',
  'pages.decoration.form.edit.title': '编辑装修报备',
  'pages.decoration.form.submit.create': '创建',
  'pages.decoration.form.submit.update': '更新',
  'pages.decoration.form.submit.cancel': '取消',

  // 表单分区
  'pages.decoration.form.sections.houseInfo': '房屋信息',
  'pages.decoration.form.sections.decorationInfo': '装修信息',
  'pages.decoration.form.sections.remarks': '备注信息',

  // 表单字段
  'pages.decoration.form.fields.houseInfo.label': '房屋信息',
  'pages.decoration.form.fields.houseInfo.placeholder': '请选择房屋',
  'pages.decoration.form.fields.houseInfo.search': '查询',
  'pages.decoration.form.fields.houseInfo.select': '选择房屋后自动填充',
  'pages.decoration.form.fields.houseInfo.required': '请选择房屋',

  'pages.decoration.form.fields.ownerInfo.label': '业主姓名',
  'pages.decoration.form.fields.ownerInfo.placeholder': '选择房屋后自动填充',

  'pages.decoration.form.fields.decorationName.label': '装修负责人',
  'pages.decoration.form.fields.decorationName.placeholder': '请输入装修负责人姓名',
  'pages.decoration.form.fields.decorationName.required': '请输入装修负责人姓名',
  'pages.decoration.form.fields.decorationName.maxLength': '装修负责人姓名不能超过50个字符',

  'pages.decoration.form.fields.decorationPhone.label': '装修负责人手机号',
  'pages.decoration.form.fields.decorationPhone.placeholder': '请输入装修负责人手机号',
  'pages.decoration.form.fields.decorationPhone.required': '请输入装修负责人手机号',

  'pages.decoration.form.fields.decorationCompany.label': '装修公司',
  'pages.decoration.form.fields.decorationCompany.placeholder': '请输入装修公司名称',
  'pages.decoration.form.fields.decorationCompany.required': '请输入装修公司名称',
  'pages.decoration.form.fields.decorationCompany.maxLength': '装修公司名称不能超过100个字符',

  'pages.decoration.form.fields.workerCount.label': '施工人数',
  'pages.decoration.form.fields.workerCount.placeholder': '请输入施工人数',
  'pages.decoration.form.fields.workerCount.required': '请输入施工人数',

  'pages.decoration.form.fields.decorationTime.label': '装修时间',
  'pages.decoration.form.fields.decorationTime.placeholder': ['开始时间', '结束时间'],
  'pages.decoration.form.fields.decorationTime.required': '请选择装修时间',

  'pages.decoration.form.fields.remarks.label': '备注',
  'pages.decoration.form.fields.remarks.placeholder': '请输入备注信息',

  // 消息提示
  'pages.decoration.message.create.success': '装修报备创建成功',
  'pages.decoration.message.create.failed': '创建失败，请稍后重试',
  'pages.decoration.message.update.success': '装修报备更新成功',
  'pages.decoration.message.update.failed': '更新失败，请稍后重试',
  'pages.decoration.message.delete.success': '删除成功',
  'pages.decoration.message.delete.failed': '删除失败',
  'pages.decoration.message.batchDelete.success': '批量删除成功',
  'pages.decoration.message.batchDelete.failed': '批量删除失败',
  'pages.decoration.message.houseSelect.success': '房屋信息已自动填充',
  'pages.decoration.message.qrCode.configError': '二维码URL配置不完整',
  'pages.decoration.message.qrCode.downloadSuccess': '二维码已下载',
  'pages.decoration.message.qrCode.copySuccess': '二维码已复制到剪贴板',
  'pages.decoration.message.qrCode.copyFailed': '复制失败，请使用下载功能',
  'pages.decoration.message.qrCode.elementNotFound': '二维码元素未找到',
  'pages.decoration.message.qrCode.copyFailedAlternative': '复制失败，请使用下载功能或尝试手动操作',
  'pages.decoration.message.listLoadFailed': '获取装修报备列表失败',

  // 确认对话框
  'pages.decoration.confirm.delete': '确定要删除这条装修报备记录吗？',
  'pages.decoration.confirm.batchDelete': '确定要删除选中的 {count} 条记录吗？',
  'pages.decoration.confirm.delete.okText': '确定',
  'pages.decoration.confirm.delete.cancelText': '取消',

  // 二维码相关
  'pages.decoration.qrCode.title': '装修报备二维码',
  'pages.decoration.qrCode.openLink': '打开链接',
  'pages.decoration.qrCode.copy': '复制二维码',
  'pages.decoration.qrCode.download': '下载二维码',
  'pages.decoration.qrCode.linkLabel': '链接地址：',

  // 表格分页
  'pages.decoration.table.pagination.total': '共 {total} 条记录',

  // Tooltip
  'pages.decoration.tooltip.viewDetail': '查看详情',
  'pages.decoration.tooltip.edit': '编辑',
  'pages.decoration.tooltip.delete': '删除',
  'pages.decoration.tooltip.generateQrCode': '生成二维码',

  // 警告消息
  'pages.decoration.warning.selectRecords': '请选择要删除的记录',
};
